var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss3Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.84,
    height: 52,
    viewBox: "0 0 36.84 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-193.633 -276.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3013",
    transform: "translate(193.633 276.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon2989",
    d: "M111.473,100.62l-3.356,37.552L93.031,142.35l-15.045-4.171L74.633,100.62Z",
    transform: "translate(-74.633 -90.35)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2991",
    d: "M268.252,163.184l2.883-32.29H256v35.687Z",
    transform: "translate(-237.672 -117.794)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2993",
    d: "M150.31,268.217l.415,4.635H161.1v-4.635Z",
    transform: "translate(-142.64 -240.99)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2995",
    d: "M153.755,176.3H142.132l.421,4.635h11.2Z",
    transform: "translate(-135.292 -158.408)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2997",
    d: "M166.574,346.241v-4.822l-.02.005-5.162-1.394-.33-3.7h-4.653l.649,7.278,9.495,2.636Z",
    transform: "translate(-148.119 -302.214)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2999",
    d: "M160,0h5.614V2.348h-3.266V4.7h3.266V7.043H160Z",
    transform: "translate(-151.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3001",
    d: "M226,0h5.614V2.041h-3.266V2.45h3.266v4.7H226V5h3.266V4.593H226Z",
    transform: "translate(-210.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3003",
    d: "M292,0h5.614V2.041h-3.266V2.45h3.266v4.7H292V5h3.266V4.593H292Z",
    transform: "translate(-269.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon3005",
    d: "M261.551,190.322l-.538,6.011-5.17,1.4v4.822l9.5-2.634.07-.783,1.089-12.2.113-1.245.837-9.382H255.843v4.635h6.531l-.422,4.746h-6.11v4.635Z",
    transform: "translate(-237.481 -158.49)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3Logo);
export default __webpack_public_path__ + "static/media/css3-logo.664a626815e8c78251632e7efc4d0284.svg";
export { ForwardRef as ReactComponent };